export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14344.3a974848.jpg";